module.exports = __webpack_public_path__ + "static/media/404.8cb0b1fb.svg";